// extracted by mini-css-extract-plugin
export default {"centeredContent":"CenteredSpinner_centeredContent__RHkEJ"};